export const STAY_CALENDAR_AB_TEST = 'IN-5001';
